import React from "react";
import Seo from "../components/seo";
import Layout from "../components/layout";
import SectionHead from "../components/newComponents/sectionHead";
import SocialMediaButtons from "../components/newComponents/socialShare";
import ImgixFilePreview from "../components/newComponents/ImgixFilePreview";
import { getPrettyDate } from "../utils/dates";
import { CgSoftwareDownload } from 'react-icons/cg';
import Matrix from "../components/matrix";
import { useParams } from "react-router";
import { useQuery } from "@apollo/client";
import { HandleQuery, ResourceEntryData } from "../queries";

export function ResourceEntry()
{
    let { slug } = useParams();

    const query_state = useQuery(ResourceEntryData(slug), {fetchPolicy: 'no-cache'});
    const { complete, view } = HandleQuery(query_state);
    if(!complete) return view;
    const data = query_state.data;
    const { entry } = data; 

  const file = entry[0].file[0];

  return (
    <Layout>
      <Seo title={entry[0].title} image={entry[0].featureImage[0]?.url} />
      <div className="main">
        <section className="section-inside" style={{ padding: "0" }}>
          <div className="shell">
            <SectionHead heading={entry[0].title} image={entry[0].featureImage[0] || null}/>
            <div className="section__inner">
              <aside className="section__aside">
                <ul className="list-info">
                  <li>
                    <p className="list__title"><strong>Date posted</strong></p>
                    <p className="list__details">{getPrettyDate(entry[0].postDate)}</p>
                  </li>
                  {file && file.title && <li>
                    <p className="list__title"><strong>File name</strong></p>
                    <p className="list__details">{file.title}</p>
                  </li>}
                  {file && file.kind && 
                    <li>
                      <p className="list__title"><strong>File type</strong></p>
                      <p className="list__details uppercase">{file.kind}</p>
                    </li>
                  }
                  
                  {file && file.url && 
                    <li>
                      <p className="list__title"><strong>Cover</strong></p>
                      <div className="list__details pr-2 relative">
                        <a href={"https://cms.genesis-analytics.com" + file.url} target="_blank" rel="noreferrer">
                          <ImgixFilePreview fileUrl={file.url} className="mt-2 border-gray-100 border-solid border aspect-[1/1]"/>
                          <span className="absolute  top-0 left-0 w-full h-full flex justify-center items-center">
                            <CgSoftwareDownload className="w-8 h-8 text-white" style={{filter: "drop-shadow( 3px 3px 5px rgba(0, 0, 0, .9))"}} alt=""/>
                          </span>
                        </a>
                      </div>
                    </li>
                  }
                </ul>             
              </aside>
              <div className="section__content">
                <div dangerouslySetInnerHTML={{ __html: entry[0].summary }} className="prose max-w-none mb-8 body-content-rich-text-bullets"/>
                <Matrix blocks={entry[0].bodyContent} />
                {file && file.url && <a href={"https://cms.genesis-analytics.com" + file.url} className="btn btn--green" target="_blank" rel="noreferrer" download>Download</a>}
                <SocialMediaButtons url={`${entry[0].url}`} title={`${entry[0].title}`} summary={entry[0].summary} twitterVia="GenesisEconomic" linkedInSource="Genesis Analytics"/>
              </div>
            </div>
          </div>
        </section>
      </div>
    </Layout>
  );
}
